import React from "react";
import "./EmptyHome.css"; // Make sure to define your CSS styles for EmptyHome in a separate file

const EmptyHome = () => {
  return (
    <div className="empty-home">
      <h2>Welcome to Beyond Movies</h2>
      <p>Search for your favorite movies and discover new ones!</p>
    </div>
  );
};

export default EmptyHome;
